//
//
//
//
//
//
//
//
//
export default {
  name: 'System',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created System');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated System');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};